import React, {Component} from 'react';
import { Trans } from 'react-i18next';

class SearchPaging extends Component {
  render() {
    let {paging} = this.props;
    console.log('File: SearchPaging.jsx Line: 6', paging);

    return (
      <React.Fragment>
        <nav aria-label="Page navigation">
          <ul className="pagination">
            <li className="pagination__item pagination__item">
              {typeof paging.next !== 'undefined' && (
                <a className="pagination__link pagination__link--next" onClick={() => this.props.callApi(paging.next)}><Trans i18nKey="search_paging.label_load_more">Load more</Trans></a>
              )}
            </li>
          </ul>
        </nav>
      </React.Fragment>
    );
  }
}

export default SearchPaging;
